import serviceSending from "../../services/sending";
import * as constant from "./constant";

export function setLoading(payload) {
  return { type: constant.LOADING, payload: payload };
}

export function setFileResponse(payload) {
  return { type: constant.FILE_RESPONSE, payload: payload };
}

export function setTextResponse(payload) {
  return { type: constant.TEXT_RESPONSE, payload: payload };
}

export function setQuestion(payload) {
  return { type: constant.QUESTION, payload: payload };
}

export function setDeleteChatResponse(payload) {
  return { type: constant.DELETE_CHAT_RESPONSE, payload: payload };
}

export function sendFile(payload) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await serviceSending.sendFile(payload);
      dispatch(setFileResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function sendText(payload) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await serviceSending.sendText(payload);
      dispatch(setTextResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}

export function deleteChatByID(avatarID) {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await serviceSending.deleteChatByID(avatarID);
      dispatch(setDeleteChatResponse(response));
    } catch (error) {
      console.error("error =>", error);
    }
    dispatch(setLoading(false));
  };
}
